// extracted by mini-css-extract-plugin
export default {"main_section":"section_main_section__8MA5Q","img2":"section_img2__XjlRb","model_button":"section_model_button__Z8S7Y"};